import { EvidenceDto } from "./evidence-dto";
import { DOCDocumentMethodDto } from './doc-document-method-dto';

export class DOCDocumentDto {
  name: string = "";
  index: number = 0;
  comment?: string;
  documentId: number = -1;
  linkedEvidences: EvidenceDto[] = [];
  selectedEvidenceMethods: DOCDocumentMethodDto[] = [];
  ppwrRelevant: boolean = true;
}
